/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner
 */
export interface EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner {
    /**
     * 
     * @type {number}
     * @memberof EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner
     */
    leaveTypeId: number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner
     */
    leaveTypeName: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner
     */
    leaveTypeColour: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner
     */
    leaveTypeAllowanceUnit: EmployeeLeaveBalancesSummaryLeaveTypeBalancesInnerLeaveTypeAllowanceUnitEnum;
    /**
     * The default allowance as of the date in question
     * @type {number}
     * @memberof EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner
     */
    defaultAllowance: number | null;
    /**
     * The aggregate of adjustments made in the year
     * @type {number}
     * @memberof EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner
     */
    adjustments: number;
    /**
     * The aggregate of (active) leave request made in the year
     * @type {number}
     * @memberof EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner
     */
    used: number;
    /**
     * The amount of leave available to use in the year
     * @type {number}
     * @memberof EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner
     */
    available: number | null;
}

/**
* @export
* @enum {string}
*/
export enum EmployeeLeaveBalancesSummaryLeaveTypeBalancesInnerLeaveTypeAllowanceUnitEnum {
    Days = 'Days',
    Hours = 'Hours'
}


/**
 * Check if a given object implements the EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner interface.
 */
export function instanceOfEmployeeLeaveBalancesSummaryLeaveTypeBalancesInner(value: object): value is EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner {
    if (!('leaveTypeId' in value) || value['leaveTypeId'] === undefined) return false;
    if (!('leaveTypeName' in value) || value['leaveTypeName'] === undefined) return false;
    if (!('leaveTypeColour' in value) || value['leaveTypeColour'] === undefined) return false;
    if (!('leaveTypeAllowanceUnit' in value) || value['leaveTypeAllowanceUnit'] === undefined) return false;
    if (!('defaultAllowance' in value) || value['defaultAllowance'] === undefined) return false;
    if (!('adjustments' in value) || value['adjustments'] === undefined) return false;
    if (!('used' in value) || value['used'] === undefined) return false;
    if (!('available' in value) || value['available'] === undefined) return false;
    return true;
}

export function EmployeeLeaveBalancesSummaryLeaveTypeBalancesInnerFromJSON(json: any): EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner {
    return EmployeeLeaveBalancesSummaryLeaveTypeBalancesInnerFromJSONTyped(json, false);
}

export function EmployeeLeaveBalancesSummaryLeaveTypeBalancesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'leaveTypeId': json['leaveTypeId'],
        'leaveTypeName': json['leaveTypeName'],
        'leaveTypeColour': json['leaveTypeColour'],
        'leaveTypeAllowanceUnit': json['leaveTypeAllowanceUnit'],
        'defaultAllowance': json['defaultAllowance'],
        'adjustments': json['adjustments'],
        'used': json['used'],
        'available': json['available'],
    };
}

  export function EmployeeLeaveBalancesSummaryLeaveTypeBalancesInnerToJSON(json: any): EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner {
      return EmployeeLeaveBalancesSummaryLeaveTypeBalancesInnerToJSONTyped(json, false);
  }

  export function EmployeeLeaveBalancesSummaryLeaveTypeBalancesInnerToJSONTyped(value?: EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'leaveTypeId': value['leaveTypeId'],
        'leaveTypeName': value['leaveTypeName'],
        'leaveTypeColour': value['leaveTypeColour'],
        'leaveTypeAllowanceUnit': value['leaveTypeAllowanceUnit'],
        'defaultAllowance': value['defaultAllowance'],
        'adjustments': value['adjustments'],
        'used': value['used'],
        'available': value['available'],
    };
}

